var _g, _g2, _g3, _g4, _path, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcomma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1750_32340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 32
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cb00ba32aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.3105 0H0.000202179V32H35.3105V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1750_32340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1750_32340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -6,
    width: 46,
    height: 45
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "2a5261153e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.615 -5.81055L-5.53875 8.10325L7.49861 38.2297L39.6523 24.3159L26.615 -5.81055Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1750_32340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1750_32340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -6,
    width: 46,
    height: 45
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "7dd187b708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.615 -5.81055L-5.53875 8.10325L7.49861 38.2297L39.6523 24.3159L26.615 -5.81055Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1750_32340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.8005 30.3532C27.549 29.4839 29.2373 28.4739 30.8508 27.3575C31.9858 26.5572 32.8853 25.4696 33.4269 24.2009C34.3393 22.2411 34.9111 20.2038 34.9284 18.0443C34.9456 17.3101 34.9054 16.5716 34.947 15.8273C35.0016 14.2095 34.572 12.6348 33.7042 11.277C32.322 8.85606 30.5591 6.65634 28.4901 4.78278C27.0807 3.46381 25.4126 2.45232 23.5749 1.82301C22.9442 1.59169 22.289 1.37186 21.6453 1.17502C18.6942 0.300022 15.7114 -0.00313896 12.697 0.910654C11.8077 1.18364 10.8795 1.3618 9.94703 1.59744C8.86226 1.87042 7.91111 2.45088 7.02462 3.11324C4.38956 5.03709 2.3364 7.46238 1.11082 10.5084C0.42979 12.2296 0.0863991 14.0831 0.156803 15.9265C0.19416 17.1118 0.208527 18.3072 0.488701 19.4724C1.55623 24.2655 4.47002 27.7023 8.57491 30.1477C10.7459 31.4164 13.2502 32.0371 15.7603 31.9581C18.6008 31.9308 21.4355 31.5701 24.2085 30.8733C24.8048 30.6994 25.414 30.4925 25.8005 30.3532Z",
    fill: "#5B96A9"
  }))))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.4109 21.7715C25.6465 22.566 24.691 22.9884 23.5502 23.0445C23.339 23.0804 23.1235 23.1034 22.9022 23.1034C21.6695 23.1034 20.5746 22.5244 19.8663 21.6264C19.4784 21.1723 19.2341 20.6666 19.1364 20.1063C19.0732 19.8261 19.0359 19.5359 19.0359 19.237C19.0359 17.1005 20.7672 15.3692 22.9022 15.3692C23.7729 15.3692 24.5732 15.6609 25.2198 16.145C25.2212 16.0962 25.2284 16.0517 25.2284 15.9999C25.2284 13.9496 23.6652 11.9008 20.5402 9.85194L20.9942 9.14648C25.4295 11.9008 27.6465 14.9252 27.6465 18.2183C27.6465 19.7298 27.2341 20.9137 26.4109 21.7715Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1750_32340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 10,
    height: 15
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "5eb7289b2e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.2764 9.10352H7.4574V23.1409H16.2764V9.10352Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1750_32340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.9502 23.0488C11.7462 23.0818 11.5378 23.1034 11.3252 23.1034C9.18868 23.1034 7.45736 21.3721 7.45736 19.237C7.45736 17.1005 9.18868 15.3692 11.3252 15.3692C12.2189 15.3692 13.0393 15.6752 13.6944 16.1853C13.6973 16.1235 13.7059 16.066 13.7059 15.9999C13.7059 13.9496 12.1427 11.9008 9.0177 9.85194L9.47172 9.14648C13.9071 11.9008 16.124 14.9252 16.124 18.2183C16.124 19.7313 15.7131 20.9152 14.8898 21.7715C14.1068 22.5847 13.1255 23.0071 11.9502 23.0488Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcomma);
export default __webpack_public_path__ + "static/media/rcomma.05621bbc49d4ed7b6a1ae911efadec5b.svg";
export { ForwardRef as ReactComponent };